import { UserGeoLocation } from '../../shared/models/geo-location.model';



export class VoucherRedeemModel {
  LogGuid: string | null;
  LogId: number | null;
  VoucherCode: string;
  ClubId: number;
  LCID: number;
  Operator: string;
  Location: UserGeoLocation;
}
